module.exports = __webpack_public_path__ + "img/1alB-a-ya.48834970.jpg";